import React, { Fragment, createContext } from 'react';
import type { LazySuspenseContextType } from './types';

export const LazySuspenseContext = createContext<LazySuspenseContextType>({
	getIsBoundaryInitialized: () => false,
	fallback: <Fragment />,
	setFallback: () => {
		// eslint-disable-next-line no-console
		console.warn('Missing <LooselySuspense /> boundary');
	},
});
